/*global jQuery: false*/
"use strict";
const AndApp = {};

AndApp.Device = {
  isSmartPhone() {
    return this.is("Sp");
  },
  isPC() {
    return this.is("Pc");
  },
  isAndAppClient() {
    return this.is("AndappClient");
  },
  isTablet() {
    return this.is("Tablet");
  },
  isAndAppClientSupport() {
    return this.is("AndappClientSupport");
  },
  is(type) {
    return true === $("#andapp-useragent-data").data(`useragentIs${type}`);
  },
  androidVersion() {
    const ua = navigator.userAgent;
    if (ua.indexOf("Android") > 0) {
      return parseFloat(ua.slice(ua.indexOf("Android") + 8));
    } else {
      return undefined;
    }
  },
  ieVersion() {
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0) {
      const array = (/(msie|rv:?)\s?([\d\.]+)/).exec(ua);
      const version = (array) ? array[2] : '';
      return version;
    } else {
      return undefined;
    }
  }
};


// jquery.smoothScroll() - v0.0.1
//
// Depends on jQuery
// http://jquery.com/
//
// Copyright 2015 Masunaga Ray
// http://www.msng.info/
//
// Released under the MIT license
// http://opensource.org/licenses/mit-license.html
//
// ※元のソースをカスタマイズしています。

// ▼TODO: 後で別ファイルに切り出す
(($) => {

  $.fn.smoothScroll = function (options) {

    const settings = $.smoothScroll.getSettings(options);

    return this.each(function () {
      const selector = $(this).attr("href");

      if (selector && (selector.match(/^#.+/))) {
        $(this).off("click.smoothScroll");
        $(this).on("click.smoothScroll", () => {
          return $.smoothScroll.to(selector, options);
        });
      }
    });
  };

  $.smoothScroll = {
    to(selector, options) {
      const settings = this.getSettings(options);

      $(window).scrollTop($(window).scrollTop() + 1);

      let scrollElement = $('html');

      if (scrollElement.scrollTop() <= 0) {
        scrollElement = $('body');
      }

      scrollElement.animate({
        scrollTop: $(selector).offset().top - settings.offset
      }, 500, "swing");

      return false;
    },

    defaults: {
      offset: 0
    },

    getSettings(options) {
      return $.extend(true, {}, this.defaults, options);
    }
  };
})(jQuery);

window.convertUrl = (urlPath) => {
  const url = new URL(urlPath);
  if (url.protocol !== 'portalapp:' && url.protocol !== 'portalapp') {
    return urlPath;
  }

  const isTauri = typeof window.__TAURI__ !== 'undefined' || typeof window.__ANDAPP__ !== 'undefined'
  if (!isTauri) {
    return urlPath
  }
  const tauri = (() => {
    if (typeof window.__ANDAPP__ !== 'undefined') {
      return window.__ANDAPP__
    }
    if (typeof window.__TAURI__ === 'undefined') {
      return undefined
    }
    if (typeof window.__TAURI__.tauri !== 'undefined' && typeof window.__TAURI__.tauri.convertFileSrc !== 'undefined') {
      return window.__TAURI__.tauri
    }
    return window.__TAURI__
  })()

  if (typeof tauri !== 'undefined' && typeof tauri.convertFileSrc !== 'undefined') {
    const portalapp = 'portalapp'
    const protocol = url.pathname.replace(/^\/\//,"")
    const path = `${url.hostname}${protocol}${url.search}`
    return tauri.convertFileSrc(path, portalapp)
  }

  return urlPath;
}

(() => {

  //scrollToTopボタン
  const scrollToTopButton = () => {
    if (!$('#js-scrollToTopButton').length) {
      return;// ページトップへ戻るボタンが存在しない場合は処理を抜ける
    }

    const $window = $(window);
    const $scriptTarget = $('#js-scrollToTopButton');
    const $footerArea = $('#js-footerArea');
    const isShowClass = "is-show";
    const isHiddenClass = "is-hidden";
    const isFixedClass = "is-fixed";
    const turningPoint = 500;

    $window.on("load scroll resize", function() {
      const documentHeight = $(document).height();
      const footerHeight = $footerArea.height() !== null ? $footerArea.height() : 0;// footerAreaが存在しない場合は念のため0を代入
      const scrollPosition = $window.height() + $window.scrollTop();
      const footerVisiblePart = footerHeight - (documentHeight - scrollPosition);
      const windowWidth = $window.width();

      if ($(this).scrollTop() > turningPoint) {
        $scriptTarget.removeClass(isHiddenClass);
        $scriptTarget.addClass(isShowClass);
      } else {
        $scriptTarget.removeClass(isShowClass);
        $scriptTarget.addClass(isHiddenClass);
      }
      // Clientの場合は footerVisiblePart が 0 以下の時だけボタン固定にする
      if (AndApp.Device.isAndAppClient() && footerVisiblePart <= 0) {
        $scriptTarget.addClass(isFixedClass);
      }
      // Client以外（＝PC (SPはこの関数自体実行されない) ）の場合は、
      // footerVisiblePart 判定に加えて画面幅 1200px 以上の時のみ fixed にする
      else if (windowWidth >= 1200 && footerVisiblePart <= 0) {
        $scriptTarget.addClass(isFixedClass);
      } else {
        $scriptTarget.removeClass(isFixedClass);
      }
    });
  };


  $(() => {

    //scrollToTopボタン実行（SP/Tabletは除く）
    if (!AndApp.Device.isSmartPhone()) {
      scrollToTopButton();
    }

    // smoothScroll実行
    $('a[href^="#"]').smoothScroll();

    // Tauri用にカスタムスキームを書き換える
    $('a[href^="portalapp://"]').each(function() {
      if (!AndApp.Device.isAndAppClient()) {
        return;
      }
      const path = $(this).attr('href');
      // 念の為Mac版のは対応しない
      if (path.match(/^portalapp:\/\/localhost/)) {
        return;
      }
      $(this).attr('href', window.convertUrl(path));
    });
  });
})();


// ▼TODO: andapp_client/common.js を作ったらいいかも
window.openBrowserIfAndAppClient = (url, openTab) => {
  const atag = document.createElement('a');
  atag.href = url;
  const fullUrl = atag.href;
  if (AndApp.Device.isAndAppClient()) {
    location.href = window.convertUrl(`portalapp://open_external_browser?url=${encodeURIComponent(fullUrl)}`);
  } else {
    openTab ? window.open(fullUrl) : location.href = fullUrl;
  }
};

window.AndApp = AndApp;
